export default class InputValidator {
    static allowChars = (str, re) =>
        str
            .split('')
            .filter((c) => c.match(re))
            .join('');

    static isValidZipCode(str) {
        const len = this.allowChars(str, /\d/).length;
        return len === 5 || len === 9;
    }

    static isValidPhoneNumber(str) {
        const len = this.allowChars(str, /\d/).length;
        return len === 3 + 7;
    }
}
